<template>
    <v-flex xs12 lg12>
        <v-card flat>
            <v-card-text>
                <v-flex xl12>
                    <v-layout wrap>

                        <v-flex xl12>
                          <h2> Foram enviadas {{total}} avaliações. </h2>
                        </v-flex>

                        <v-flex v-for="(res,index) in registries" :key="index" xl12 style="font-size: 18px;">
                            <span v-if="res.value === '1'"><b>{{res.score}}</b> <v-icon color="orange">star</v-icon></span>
                            <span v-if="res.value === '2'"><b>{{res.score}}</b> <v-icon color="orange">star</v-icon><v-icon color="orange">star</v-icon></span>
                            <span v-if="res.value === '3'"><b>{{res.score}}</b> <v-icon color="orange">star</v-icon><v-icon color="orange">star</v-icon><v-icon color="orange">star</v-icon></span>
                            <span v-if="res.value === '4'"><b>{{res.score}}</b> <v-icon color="orange">star</v-icon><v-icon color="orange">star</v-icon><v-icon color="orange">star</v-icon><v-icon color="orange">star</v-icon></span>
                            <span v-if="res.value === '5'"><b>{{res.score}}</b> <v-icon color="orange">star</v-icon><v-icon color="orange">star</v-icon><v-icon color="orange">star</v-icon><v-icon color="orange">star</v-icon><v-icon color="orange">star</v-icon></span>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-card-text>
        </v-card>
    </v-flex>
</template>
<script>
    export default {
        name: 'rantings-list',
        data() {
            return {
                success: false,
                error: false,
                dialog: false,
                messages: '',
                total: '',
                registries: [],
                loading: true,
            }
        },
        mounted() {
            this.getDataFromApi()
        },
        methods: {
            getDataFromApi() {
                var self = this
                self.$store.commit('setLoading', true)
                self.axios.get('/list-ratings.json', {
                    headers: {
                        'Authorization': self.$store.state.token
                    }
                }).then((response) => {
                    self.$store.commit('setLoading', false)
                    self.registries = response.data.response
                    self.total = response.data.total
                })
            }
        }
    }
</script>
